<div container-principal>
    <header class="d-flex align-items-center">
        <button (click)="fecharModal()" class="d-flex align-items-center">
            <object data="assets\agview-connect\Arrow-left.svg" type="image/svg+xml">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.ARROW" | transloco }}</object>
        </button>
        <object *ngIf="erros" data="assets\agview-connect\alert.svg" type="image/svg+xml">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.ALERT" | transloco }}</object>
        <span class="font-11"><b>
            {{ (erros ? 
                "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.WARNING" : 
                "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.VALIDATION_TITLE") | transloco }}
        </b></span>
    </header>
    <article class="w-100 d-flex justify-content-center">
        @if(!erros) {
        <span>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.EXIT_CONFIRMATION" | transloco }}</span>
        }@else {
        <span *ngIf="erros.erro == 'muda'">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.ERROR_MUDA" | transloco }}</span>
        <span *ngIf="erros.erro == 'solido'">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.ERROR_SOLIDO" | transloco }}</span>
        <span *ngIf="erros.erro == 'liquido'">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.ERROR_LIQUIDO" | transloco }}</span>
        }
    </article>
    <footer class="d-flex w-100 gp-05">
        @if(!erros) {
        <button class="btn-voltar" (click)="cancelarAlteracao()">
            <object data="assets\agview-connect\cancel.svg" type="image/svg+xml">Check</object>
            <span>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.EXIT_WITHOUT_VALIDATING" | transloco }}</span>
        </button>
        }
        <button (click)="erros ? fecharModal() : confirmar()">
            @if(erros) {
            <object data="assets\agview-connect\check.svg" type="image/svg+xml">Check</object>
            <span>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.CONFIRM" | transloco }}</span>

            } @else {
            <object data="assets\agview-connect\check.svg" type="image/svg+xml">Check</object>
            <span>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_CONFIRMACAO.VALIDATE" | transloco }}</span>
            }
        </button>
    </footer>
</div>